import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { X, Check } from 'lucide-react';
export function ProFeatures() {
  return <section className="py-12 md:py-20 bg-[#FBF7F0]" data-id="element-207">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <SectionHeader title="¿QUÉ AGREGA EL MEGAPACK PRO?" subtitle="Para familias con hijos pre-adolescentes o mamás que necesitan herramientas para ellas también" data-id="element-209" />

        <div className="space-y-6 md:space-y-8" data-id="element-210">
          {/* Feature 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-5 md:p-8 shadow-sm border border-[#1E2A4A]/10" data-id="element-211">
            <div className="inline-block bg-[#1E2A4A] text-white font-bold px-2 py-1 md:px-3 md:py-1 rounded-lg text-xs md:text-sm mb-3 md:mb-4" data-id="element-212">
              01
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-[#1E2A4A] mb-2 md:mb-4" data-id="element-213">
              Tu hijo pre-adolescente con TDAH (Tomo 7)
            </h3>
            <p className="text-[#1E2A4A]/80 mb-4 md:mb-6 font-medium text-sm md:text-base" data-id="element-214">
              El tomo que las mamás de chicos de 11 a 13 años buscan y no
              encuentran en ningún lado.
            </p>

            <div className="grid sm:grid-cols-2 gap-3 md:gap-4" data-id="element-215">
              <div className="bg-red-50 p-3 md:p-4 rounded-xl border border-red-100" data-id="element-216">
                <div className="flex items-center gap-1.5 md:gap-2 text-red-700 font-bold mb-1.5 md:mb-2 text-sm md:text-base" data-id="element-217">
                  <X size={16} className="md:w-[18px] md:h-[18px]" data-id="element-218" /> Sin Pro
                </div>
                <p className="text-xs md:text-sm text-red-900/80" data-id="element-219">
                  Estrategias pensadas para niños de 5 a 10 años — útiles, pero
                  incompletas para esta etapa.
                </p>
              </div>
              <div className="bg-[#8A9A86]/10 p-3 md:p-4 rounded-xl border border-[#8A9A86]/30" data-id="element-220">
                <div className="flex items-center gap-1.5 md:gap-2 text-[#4A5D46] font-bold mb-1.5 md:mb-2 text-sm md:text-base" data-id="element-221">
                  <Check size={16} className="md:w-[18px] md:h-[18px]" data-id="element-222" /> Con
                  Pro
                </div>
                <p className="text-xs md:text-sm text-[#1E2A4A]/80" data-id="element-223">
                  Guía específica para la pre-adolescencia con TDAH —
                  autoestima, pares, pantallas, presión académica y resistencia
                  a la autoridad. Todo lo que cambia cuando el niño crece y el
                  TDAH se transforma.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Feature 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-5 md:p-8 shadow-sm border border-[#1E2A4A]/10" data-id="element-224">
            <div className="inline-block bg-[#1E2A4A] text-white font-bold px-2 py-1 md:px-3 md:py-1 rounded-lg text-xs md:text-sm mb-3 md:mb-4" data-id="element-225">
              02
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-[#1E2A4A] mb-2 md:mb-4" data-id="element-226">
              Cuidarte para poder cuidarlo (Tomo 8)
            </h3>
            <p className="text-[#1E2A4A]/80 mb-4 md:mb-6 font-medium text-sm md:text-base" data-id="element-227">
              El tomo que nadie espera pero todas las mamás necesitan.
            </p>

            <div className="grid sm:grid-cols-2 gap-3 md:gap-4" data-id="element-228">
              <div className="bg-red-50 p-3 md:p-4 rounded-xl border border-red-100" data-id="element-229">
                <div className="flex items-center gap-1.5 md:gap-2 text-red-700 font-bold mb-1.5 md:mb-2 text-sm md:text-base" data-id="element-230">
                  <X size={16} className="md:w-[18px] md:h-[18px]" data-id="element-231" /> Sin Pro
                </div>
                <p className="text-xs md:text-sm text-red-900/80" data-id="element-232">
                  Herramientas para acompañar a tu hijo — fundamentales, pero
                  sin contemplar a quien sostiene todo.
                </p>
              </div>
              <div className="bg-[#8A9A86]/10 p-3 md:p-4 rounded-xl border border-[#8A9A86]/30" data-id="element-233">
                <div className="flex items-center gap-1.5 md:gap-2 text-[#4A5D46] font-bold mb-1.5 md:mb-2 text-sm md:text-base" data-id="element-234">
                  <Check size={16} className="md:w-[18px] md:h-[18px]" data-id="element-235" /> Con
                  Pro
                </div>
                <p className="text-xs md:text-sm text-[#1E2A4A]/80" data-id="element-236">
                  Acompañamiento real para la mamá agotada. Culpa, frustración,
                  límites, pedir ayuda y recarga mínima viable. Porque no podés
                  dar lo que no tenés.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}